import {ErrorCode} from './ErrorCode';

export class ApplicationError extends Error{
  public readonly code: ErrorCode;

  constructor(message: string, code: ErrorCode) {
    super(message);
    this.code = code;
  }
}